/*!
 * e3-common JavaScript Library v0.0.32
 *
 * Released under the MIT license
 *
 * Date: 2015-06-01T18:49Z
 */

(function(global, factory) {

  if (typeof define === 'function' && define.amd) {
    define('e3-common', 
      ['jquery', 'underscore', 'vertebrae', 'bluebird', 'handlebars', 'moment', 'bootstrap'], factory);
  } else {
    factory((global.jQuery || global.$), global._, {}, global.Promise, global.Handlebars, global.moment);
  }

}(this, function($, _, Vertebrae, Promise, Handlebars, moment) {

  var BrowserCommon = {

    /**
     * Is the current user using Internet Explorer?
     *
     * @function
     *
     * @return {Boolean}
     */
    isIE: function() {
      var userAgent = navigator.userAgent.toLowerCase(),
          valid     = userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1;

      // If valid, return IE version number
      return valid && parseInt(userAgent.split('msie')[1]);
    }

  };


  var StringCommon = {

    newLineToBr: function(str) {
      return String(str).replace(/\r\n|\r|\n/g, '<br />');
    },

    brToNewLine: function(str) {
      return String(str).replace(/<br\s?\/?>/g, '\n');
    },

    /**
     * Converting the passed string to only have capitalize the words.
     * 
     * @function
     *
     * @param {String} str The string we want to proper cased.
     * 
     * @return {String} The proper cased string.
     */
    toProperCase: function(str) {
      return String(str).replace(/\w\S*/g, function(word) {
        return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
      });
    },

    /**
     * Take an escaped html string and unescape it.
     *
     * @function
     *
     * @param {String} string 
     * 
     * @return {String}        
     */
    unescapeHTML: function(string) {
      return $('<div/>').html(string).text();
    }

  };

  // mixin everything from Vertebrae.String into E3Common.String
  _.extend(StringCommon, Vertebrae.String);


  var ObjectCommon = {

    namespace: function() {
      if (arguments.length > 2) {
        return ObjectCommon.setPropertyByNamespace.apply(this, arguments);
      }
      return ObjectCommon.getPropertyByNamespace.apply(this, arguments);
    }

  };

  ObjectCommon.getPropertyByNamespace = Vertebrae.Object.getPropertyByNamespace;
  ObjectCommon.setPropertyByNamespace = Vertebrae.Object.setPropertyByNamespace;


  /**
   * DropCommon class for use with EVIDrag
   * @param {EVIDrag} drag     EVIDrag instance
   * @param {String} selector The selector to delegate over
   */
  var DropCommon = function(drag, selector) {
    var that = this;

    this.drag = drag;
    this.selector = selector;

    // Events objects to add callbacks to
    this._callbacks = {
      init  : $.Callbacks(),
      enter : $.Callbacks(),
      exit  : $.Callbacks(),
      drop  : $.Callbacks(),
      move  : $.Callbacks(),
      end   : $.Callbacks()
    };

    // We need to store the currently hovered item so when draggin ends we can fire the drop event
    this
        .init(function() { this.setupDrop(); })
        .enter(function(el) { this.setCurrentlyHovered(el); })
        .exit(function(el) { this.setCurrentlyHovered(null); })
        .end(function() { this.teardownDrop(); });

    // We need to be notified when dragging inits
    // We need to be notified when dragging ends
    // We also need to bind on the mouse enter/leave events on the elemnts that match the given selector
    this.drag
        .init(function() { that._callbacks.init.fire.apply(that, arguments); })
        .end(function() { that.handleDragEnd.apply(that, arguments); })
        .move(function() { that.handleDragMove.apply(that, arguments); });
  };


  DropCommon.prototype = {

    init: function(fn) {
      this._callbacks.init.add(fn);

      return this;
    },

    enter: function(fn) {
      this._callbacks.enter.add(fn);

      return this;
    },

    exit: function(fn) {
      this._callbacks.exit.add(fn);

      return this;
    },

    drop: function(fn) {
      this._callbacks.drop.add(fn);

      return this;
    },

    move: function(fn) {
      this._callbacks.move.add(fn);

      return this;
    },

    end: function(fn) {
      this._callbacks.end.add(fn);

      return this;
    },

    trigger: function(name) {
      var args = [].concat.apply([], arguments).slice(1);

      if (this._callbacks[name]) {
        this._callbacks[name].fire.apply(this, args);
      }

      return this;
    },

    plugin: function(plugin) {
      plugin = plugin || {};

      var init  = plugin.init,
          enter = plugin.enter,
          exit  = plugin.exit,
          end   = plugin.end;

      if (init) {
        this.init(init);
      }
      if (enter) {
        this.enter(enter);
      }
      if (exit) {
        this.exit(exit);
      }
      if (end) {
        this.end(end);
      }

      return this;
    },

    setCurrentlyHovered: function(el) {
      if (el) {
        this.currentlyHovered = $(el);
      } else {
        this.currentlyHovered = null;
      }
    },

    getCurrentlyHovered: function() {

      return this.currentlyHovered;
    },

    getCurrentlyDragged: function() {

      return this.drag.getCurrentlyDragged();
    },

    isDragging: function() {

      return !!this.drag._dragging;
    },

    setupDrop: function() {
      this._dropPointer = null;
      this._dropstack = [];
      this.calculateBounds();

    },

    dropzonesMoved: function() {
      this.calculateBounds();
    },


    calculateBounds: function() {
      var dropzones = this.drag.$el.find(this.selector),
          i         = 0,
          len       = dropzones.length,
          bounds    = [],
          el        = null,
          offset    = null;

      for (i = 0; i < len; ++i) {
        el     = dropzones.eq(i);
        offset = el.offset();

        bounds.push({
          element : el.get(0),
          top     : offset.top,
          left    : offset.left,
          right   : offset.left + el.outerWidth(),
          bottom  : offset.top + el.outerHeight()
        });
      }

      this._dropBounds = bounds;
    },

    teardownDrop: function() {
      this._dropPointer = null;
      this._dropstack   = null;
      this._dropBounds  = null;
    },

    boundsCheck: function(pos,bounds) {
      var that = this;

      if (pos.x >= bounds.left && pos.x < bounds.right && pos.y >= bounds.top && pos.y < bounds.bottom) {
        //it is within
        if (!bounds.element._entered) {
          bounds.element._entered = true;
          this._boundscheckStackAdded++;
          //we just entered
          // add to callback stack since all mouse enters need to happen AFTER mouse leaves
          this._boundsCheckStack.add(function() {
            that.handleMouseEnter({currentTarget: bounds.element, bounds: bounds});
          });
        }
      } else {
        //it is without
        if (bounds.element._entered) {
          bounds.element._entered = false;
          this._boundscheckStackRemoved++;
          //we just exited
          that.handleMouseLeave({currentTarget:bounds.element, bounds: bounds});
        }
      }
    },

    handleMouseEnter: function(ev) {
      var last = this._dropstack[this._dropstack.length-1],
          doEnter;

      doEnter = function() {
        this._dropPointer = this._dropstack.length;
        this._dropstack.push(ev.currentTarget);
        if (last) {
          last = $(last);
          this.trigger('exit', last, ev);
        }
        this.trigger('enter', $(ev.currentTarget), ev);

        clearTimeout(this._mouseEnterTimeout);
      }.proxy(this);

      if (this._dropPointer == null) {
        doEnter();
      } else {
        if ($.contains(ev.currentTarget,this._dropstack[this._dropPointer])) {
          //dont call enter, just add to the stack
          this._dropstack.splice(this._dropPointer,0,ev.currentTarget);
        } else {
          //just add to the end of the stack and call enter
          doEnter();
        }
      }
    },

    handleMouseLeave: function(ev) {
      var last = $(this._dropstack[this._dropstack.length-2]),
          lastIndex = this._dropstack.length-2,
          doEnter;

      doEnter = function() {
        if (this._dropstack.length) {
          ev._nestedDropAction = true;
          this._dropPointer = lastIndex;
          this.trigger('enter', last, ev, true);
        } 
      }.proxy(this);

      this.trigger('exit', $(ev.currentTarget), ev);

      this._dropstack.pop();
      if (this._dropPointer == this._dropstack.length) {
        this._dropPointer = this._dropstack.length - 1;
      }

      clearTimeout(this._mouseEnterTimeout);
      this._mouseEnterTimeout = setTimeout(doEnter,0);
    },

    handleDragEnd: function(ev, drag) {
      var currentlyHovered = this.currentlyHovered;

      if (this.currentlyHovered && this.currentlyHovered.length) {
        this.trigger('exit', currentlyHovered, ev, drag);
        this.trigger('drop', currentlyHovered, ev, drag);
      }

      this.currentlyHovered = null;
    },

    refireLastDragMove: function() {
      if (this._lastDragMoveArgs) {
        this.handleDragMove.apply(this,this._lastDragMoveArgs);
      }
    },

    handleDragMove: function(ev) {
      this._lastDragMoveArgs = arguments;
      var bounds    = this._dropBounds,
          cursorPos = { x:ev.gesture.center.pageX, y: ev.gesture.center.pageY },
          i         = null;

      this._boundsCheckStack = $.Callbacks();

      for (i = bounds.length-1; i >= 0 ; i--) {
        this.boundsCheck(cursorPos, bounds[i]);
      }

      this._boundsCheckStack.fire();
      this._boundsCheckStack = null;

      if (this.currentlyHovered != null) {
        this.trigger('move', cursorPos, this.currentlyHovered);
      }
    }
  };


  var nextId = function() {
    return this._nextEventId ? this._nextEventId++ : this._nextEventId = 1;
  }

  var proxy = function(fn, obj) {
    return function() {
      return fn.apply(obj, arguments);
    };
  };

  var functionate = function(obj) {
    if (typeof obj !== 'function') {
      return function() { return obj; }
    }

    return obj;
  };

  var DragCommon = function(el, selector, options) {
    var that = this;

    this._eventId = '.'+'evidrag'+nextId();
    this.$el = $(el);
    this.el = this.$el.get(0);
    this.selector = selector;
    this.options = options || {};

    this._callbacks = {
      init  : $.Callbacks(),
      start : $.Callbacks(),
      move  : $.Callbacks(),
      end   : $.Callbacks(),
      release: $.Callbacks()
    };

    this._cache   = {};
    this._getters = {};

    // Don't apply to IE 9
    if (BrowserHelper.isIE() != 9) {
      this.options.stop_browser_behavior = {
        userSelect: true
      };
    } 

    var hammerObj = this.$el.hammer(this.options)
            .on('drag'+this._eventId, proxy(function() { this._dragging && this.handleDragMove.apply(this, arguments); }, this)) 
            .on('touch'+this._eventId, this.selector, proxy(this.handleDragInit, this))
            .on('dragstart'+this._eventId, proxy(this.handleDragStart, this))
            .on('dragend'+this._eventId, proxy(function() { this._dragging && this.handleDragEnd.apply(this, arguments); }, this))
            .on('release'+this._eventId, this.selector, proxy(this.handleDragRelease, this))
            .on('release'+this._eventId, proxy(function() { this._wasDragging && this.handleDragRelease.apply(this, arguments); }, this));
  };

  DragCommon.prototype = {

    defaults: {
      container: function() {

        return this.$el;
      },

      ghostPosition: function(el) {
        var container = this.get('container'),
            elemOff   = el.offset(),
            offset    = container.offset(),
            pos       = { top: elemOff.top-offset.top, left: elemOff.left-offset.left};
        return pos;
      },

      isDraggedElement: function(el, dragged) {

        return el === dragged;
      },

      bounds: function() {
        var ghost           = this.get('ghost'),
            placeholder     = this.get('placeholder'),
            sortableElement = this.get('sortableElement'),
            draggable       = this.get('sortableElements').not(ghost).not(placeholder ? sortableElement : null),
            i               = 0,
            len             = draggable.length,
            bounds          = [],
            el              = null,
            offset          = null;

        if (!draggable.has(placeholder.get(0))) {
          draggable = draggable.add(placeholder);
        }

        for (i = 0; i < len; ++i) {
          el     = draggable.eq(i);
          offset = el.offset();

          bounds.push({
            element : el.get(0),
            top     : offset.top,
            left    : offset.left,
            right   : offset.left + el.outerWidth(),
            bottom  : offset.top + el.outerHeight()
          });
        }

        return bounds;
      },

      sortableElements: function(filter) {

        return this.$el.find(this.selector).not(filter);
      },

      dragElement: function(el) {

        return el;
      }
    },

    init: function(fn) {
      this._callbacks.init.add(fn);

      return this;
    },

    start: function(fn) {
      this._callbacks.start.add(fn);

      return this;
    },

    move: function(fn) {
      this._callbacks.move.add(fn);

      return this;
    },

    end: function(fn) {
      this._callbacks.end.add(fn);

      return this;
    },

    release: function(fn) {
      this._callbacks.release.add(fn);

      return this;
    },

    trigger: function(name) {
      var args = [].concat.apply([], arguments).slice(1);
      if (this._callbacks[name]) {
        this._callbacks[name].fire.apply(this, args);
      }

      return this;
    },

    delegateDrop: function(selector) {

      var drop = new Drop(this, selector),
          dd = this.dropDelegates = this.dropDelegates || [];
      dd.push(drop);
      return drop;
    },

    setCurrentlyDragged: function(el) {
      if (el) {
        this.currentlyDragged = $(el);
      } else {
        this.currentlyDragged = null;
      }

      return this;
    },

    getCurrentlyDragged: function() {

      return this.currentlyDragged
    },

    handleDragMove: function(ev) {
      // console.log("Move" + this._eventId,this._dragging , this._dragStarted);
      if (this._dragging && this._dragStarted && this._draggingObject == this) {
        // console.log("legit yo!");
        this._lastDragMoveArgs = arguments;
        this._callbacks.move.fire.apply(this, arguments);
      }
    },

    handleDragInit: function(ev) {
      // console.log("Init" + this._eventId);
      this._dragging = true;
      this._draggingObject = this;
      this.setCurrentlyDragged(ev.currentTarget);
      this._callbacks.init.fire.apply(this, arguments);
    },

    handleDragRelease: function(ev) {
      // console.log("Release" + this._eventId);
      this._wasDragging = false;
      this._callbacks.release.fire.apply(this, arguments);
    },

    handleDragStart: function(ev) {
      if (this._draggingObject != this || !this._dragging) {
        return;
      }
      // console.log("Start" + this._eventId, this.selector);
      this._dragStarted = true;
      $('body').addClass('unselectable');
      if (ev.gesture) {
        ev.gesture.preventDefault()
      } else if (ev.originalEvent) {
        ev.originalEvent.preventDefault();
      }
      this._callbacks.start.fire.apply(this, arguments);
    },

    handleDragEnd: function(ev) {
      if (this._draggingObject != this || !this._dragging) {
        return;
      }
      // console.log("End" + this._eventId);
      $('body').removeClass('unselectable');

      if (this._dragStarted) {
        this._callbacks.end.fire.apply(this, arguments);
      }
      this._dragging = false;
      this._wasDragging = true;
      this._dragStarted = false;
      this.setCurrentlyDragged(null);
      this._cache = {};
    },

    plugin: function(plugin) {
      plugin = plugin || {};

      var init      = plugin.init,
          start     = plugin.start,
          move      = plugin.move,
          end       = plugin.end,
          release   = plugin.release,
          callbacks = plugin.callbacks;

      if (init) {
        this.init(init);
      }
      if (start) {
        this.start(start);
      }
      if (move) {
        this.move(move);
      }
      if (end) {
        this.end(end);
      }

      if (release) {
        this.release(release);
      }

      if (callbacks) {
        var i    = 0,
            that = this,
            len  = callbacks.length || 0;

        for (i = 0; i < len; ++i) {
          this.addCallback(callbacks[i]);
        }
      }

      return this;
    },

    addCallback: function(name) {
      var that = this;

      if (this._callbacks[name] == null && this[name] == null) {
        this._callbacks[name] = $.Callbacks();

        that[name] = function(fn) {
          that._callbacks[name].add(fn);

          return that;
        };
      }
    },

    get: function(name) {
      var cache  = this._cache || (this._cache = {}),
          args   = [].concat.apply([], arguments).slice(1),
          getter = null,
          value  = cache[name];

      if (!value) {
        getter = (this._getters[name] || this.defaults[name]);
        if (getter) {
          value = (cache[name] = getter.apply(this, args));
        }
      }

      return value;
    },

    clear: function(name) {
      var cache = this._cache || (this._cache = {});

      cache[name] = null;

      return this;
    },

    set: function(name, fn) {
      this._getters[name] = functionate(fn);

      return this;
    },

    has: function(name) {

      return !!this._getters[name];
    },

    isCached: function(name) {
      var cache = this._cache || (this._cache = {});

      return !!cache[name];
    },

    destroy: function() {
      this._destroyed = true;
      this.$el.off(this._eventId);
    }

  };


  DragCommon.delegate = function(el, selector, options) {
    return new this(el, selector, options);
  };

  var ScrollerPlugin = {
    startScroll: function(speed,el, dropDelegates) {
      var realEl = el.get(0);
      realEl._scrollSpeed    = speed;
      realEl._scrollInterval = setInterval(function() {
        el.scrollTop(el.scrollTop()+realEl._scrollSpeed);
        //let the dropDelegate know that its dropzones moved;
        for (var i = 0, len = (dropDelegates ? dropDelegates.length : 0); i < len; i++) {
          dropDelegates[i].dropzonesMoved();
        }
      },1)
    },

    isScrolling: function(el) {
      return !!el.get(0)._scrollInterval;
    },

    setSpeed: function(speed,el) {
      el.get(0)._scrollSpeed    = speed;
    },

    killScroll: function(el) {
      var realEl = el.get(0);
      el.get(0)._scrollSpeed = 0;
      clearInterval(realEl._scrollInterval)
      realEl._scrollInterval = undefined;
    }
  };


  // Store commonly used plugins here
  DragCommon.plugins = {};

  DragCommon.plugins.scroller = {

    init: function(ev) {
    },
    move: function(ev) {
      if (this.has('scrollContainer')) {
        var sc      = this.get('scrollContainer'),
            offset  = sc.offset(),
            top     = offset.top,
            left    = offset.left,
            bottom  = top + sc.outerHeight(),
            right   = left + sc.outerWidth(),
            cursorX = ev.gesture.center.pageX,
            cursorY = ev.gesture.center.pageY,
            speed   = 0;

        if (cursorX > left && cursorX < right && cursorY > top && cursorY < bottom) {
          if (cursorY < top+100) {
            speed = -(100+(top-cursorY));
          }
          if (cursorY > bottom-100) {
            speed = 100- (bottom - cursorY);
          }
          speed /= 5;
          if (speed) {
            if (ScrollerPlugin.isScrolling(sc)) {
              ScrollerPlugin.setSpeed(speed,sc);
            } else {
              ScrollerPlugin.startScroll(speed,sc,this.dropDelegates);
            }
          } else {
            ScrollerPlugin.killScroll(sc);
          }
        }
      }
    },
    end: function(ev) {
      ScrollerPlugin.killScroll(this.get('scrollContainer'));
    }
  }

  // plugin to show a ghost on move
  DragCommon.plugins.ghost = {
    init: function(ev) {
      this._originalElement = $(ev.currentTarget);
    },
    start: function(ev) {
      if (this.has('ghost')) {
          var container = this.get('container'),
              elemOff   = this._originalElement.offset(),
              offset    = container.offset(),
              that      = this,
              pos       = { top: elemOff.top-offset.top, left: elemOff.left-offset.left};

          this.get('ghostPosition', this._originalElement);

          this.get('ghost', this._originalElement).css({
            zIndex   : '2000',
            position : 'absolute'
          });

          this.get('ghost').on('mousewheel', function(ev) {
            that.trigger('scroll', ev);
          });


          container.append(this.get('ghost'));
      }
    },
    move: function(ev) {
      if (this.has('ghost')) {
        var pos       = this.get('ghostPosition', this._originalElement);
        this.get('ghost').css({
          top: pos.top + ev.gesture.deltaY,
          left: pos.left + ev.gesture.deltaX
        });

      }
    },
    end: function(ev) {
      var ghost = this.get('ghost');

      if (ghost) {
        ghost.remove();
      }
    },

    callbacks: ['scroll']
  };

  var SortablePlugin = {
    boundsCheck: function(pos, bound) {
      var that = this;

      if (pos.x >= bound.left && pos.x < bound.right && pos.y >= bound.top && pos.y < bound.bottom) {
        //it is within
        if (!bound._entered) {
          bound._entered = true;
          //we just entered
          return true;
        }
      } else {
        //it is without
        if (bound._entered) {
          bound._entered = false;
          //we just exited

        }
      }
    },

    processBounds: function(bounds, draggedElement) {
      var i        = 0,
          len      = bounds ? bounds.length || 0 : 0;

      for (i = 0; i < len; ++i) {
        //Loop through and index all the bounds
        if (this.get('isDraggedElement', bounds[i].element, draggedElement)) {
          //Mark a flag if we found the element thats being dragged
          bounds[i]._draggedElement = true;
          if (this._startIndex == null) {
            this._startIndex = i;
          }
          this._currentIndex = i;
        }
        bounds[i]._dropSpace = i;
        this.clear('isDraggedElement');
      }
    }
  };

  DragCommon.plugins.sortable = {
    init: function(ev, drag) {
      DragCommon.plugins.ghost.init.apply(this, arguments);
      // Store a reference to the original element that we plan on dragging.
      this.get('sortableElement', $(ev.currentTarget));
    },

    start: function(ev, dd) {
      DragCommon.plugins.ghost.start.apply(this, arguments);
      var placeholder = null,
          el          = this.get('sortableElement');

      // Do we have a place holder generation function?
      if (this.has('placeholder')) {
        placeholder = this.get('placeholder', el);
        // We do.  Create the placeholder and hide the original dragged element.
        el.hide().before(placeholder);
      }

      var sortableItemInList = placeholder ? $(placeholder).get(0) : el.get(0);

      //Get the bounds calculations for all draggable elements.  Also add/remove the placeholder/original element
      //from the bound calc list if we showed a placeholder.
      SortablePlugin.processBounds.call(this, this.get('bounds'), sortableItemInList);
    },

    move: function(ev, dd) {
      DragCommon.plugins.ghost.move.apply(this, arguments);
      var bounds       = this.get('bounds'),
          cursorPos    = { x:ev.gesture.center.pageX, y: ev.gesture.center.pageY },
          i            = 0,
          enteredIndex = null,
          elementIndex = null,
          len          = bounds.length,
          dragged      = null,
          entered      = null;

      for (i = 0; i < len; ++i) {
        // Go through elements, if it isn't the one we're dragging, did we collide with it?
        if (bounds[i]._draggedElement !== true && SortablePlugin.boundsCheck.call(this, cursorPos, bounds[i])) {
          // We collided with an element, store it
          entered = bounds[i];
        } else if (bounds[i]._draggedElement === true) {
          //We found the element we're dragging, store that in a reference.
          dragged = bounds[i];
        }
      }
      
      //Do we have a reference to the element we're dragging, and a reference to the new element we dragged into?
      if (entered && dragged) {
        //Grab the index of the element we entered,
        //detach what we're dragging
        var insertIndex    = entered._dropSpace,
            el             = $(dragged.element).detach(),
            placeholder    = this.get('placeholder'),
            enteredElement = $(entered.element),
            action         = 'before';

        // Does what we're dragging need to go above or below what we just entered?
        if (insertIndex > dragged._dropSpace) {
          action = 'after';
        }
        //Insert what we're dragging above/below the element we entered
        enteredElement[action](el);

        //Reset the bounds
        this.clear('bounds');
        // Reset the sortable elements
        this.clear('sortableElements');

        //re-cache bounds
        SortablePlugin.processBounds.call(this, this.get('bounds'), el.get(0));
       
        this._didSwap = true;
      }
    },

    end: function() {
      DragCommon.plugins.ghost.end.apply(this, arguments);
      var placeholder = this.get('placeholder'),
          bounds      = this.get('bounds');

      if (placeholder) {
        // We have a placeholder we've been using.  Grab the original element we wanted to drag, 
        // insert it after the placeholder, and remove the placeholder
        placeholder = $(placeholder);
        this.get('sortableElement').insertAfter(placeholder).show();
        placeholder.remove();
      }

      if (this._didSwap === true) {
        //Did we actually do a replace?  if so, trigger an event for all of our listeners.
        this.trigger('swap', this.getCurrentlyDragged(), this._startIndex, this._currentIndex);
      }

      this._startIndex   = null;
      this._currentIndex = null;
      this._didSwap      = null;
    },

    callbacks: ['swap']
  };

    
  var SidebarView = Vertebrae.View.extend({

    templates: {
      'sidebar.init.container'    : 'renderInitialContainer',
      'sidebar.section'           : 'renderSidebarSection',
      'sidebar.section.item'      : 'renderSidebarSectionItem'
    },

    events: {
      'click .sidebar-section-header.collapsable' : 'handleCollapseSection',
      'click .sidebar-section-add-item'           : 'handleAddNewItem',
      'click .sidebar-section-delete-item'        : 'handleDeleteItem',
      'click .sidebar-section-item'               : 'handleSelectItem'
    },

    properties: [
      'sections',
      'singleSelect',
      'title'
    ],

    initialize: function() {
      this._super.apply(this, arguments);

      // Used for delegate functions
      this._getters = this._getters || {};
    },

    render: function(sections) {

      if (!_.isArray(sections)) {
        sections = [sections];
      }

      this.$el.html(this.renderInitialContainer(this));

      this.setSections(sections);
      this.renderSections();
      
      return this;
    },

    refresh: function(newSections) {      
      if (newSections) {
        this.setSections(newSections);
      }

      this.renderSections();

      return this;
    },

    renderSections: function() {
      var sections          = this.getSections(),
          sectionsContainer = null,
          $sections         = null,
          $section          = null,
          $header           = null,
          itemsContainer    = null;

      // Render sections
      sectionsContainer = this.renderSidebarSection(sections, true);
      $sections         = sectionsContainer.children();

      for (var i = 0, len = sections.length; i < len; i++) {

        $section = $sections.eq(i);
        // Render items and data bind
        itemsContainer = $section.find('.sidebar-section-items');
        $header        = $section.find('.sidebar-section-header');

        if (sections[i].collapsable) {
          $header.addClass('collapsable');
        }
        
        // Allows you to specify your own template for the section item
        if (sections[i].template) {
          itemsContainer.html(this.template(sections[i].template, sections[i].items, true));
        } else {
          itemsContainer.html(this.renderSidebarSectionItem(sections[i].items, true));
        }

        var items  = itemsContainer.find('.sidebar-section-item');

        if (sections[i].tabs) {
          items.addClass('tab-highlight');
        } else {
          items.addClass('border-highlight');
        }
      }
      
      this.getSidebarScroller().html(sectionsContainer);

      this.initiateDragAndDrop();
    },

    initiateDragAndDrop: function() {
      var sections = this.$('.sidebar-section.draggable'),
          that     = this;

      for (var i = 0, len = sections.length; i < len; i++) {
        (function(index) {
          Drag.delegate(that.getSidebarContainer(), '.sidebar-section-item .dragger', { drag_min_distance: 5 })
              .init(function(ev) {
                var el = $(ev.currentTarget).closest('.sidebar-section-item');
                this.set('item', el);
              })
              .set('placeholder', function(el) {
                return $('<div/>').height(el.outerHeight()).addClass(el.attr('class'));
              })
              .plugin(Drag.plugins.sortable)
              .set('ghostPosition', function() {
                var elemOff = this.get('item').offset();
                return { top: elemOff.top, left: 0 };
              })
              .set('sortableElements', function() {
                return $(sections.get(index)).find('.sidebar-section-item');
              })
              .set('sortableElement', function(el) {
                return el.closest('.sidebar-section-item');
              })
              .set('ghost', function(el) {
                return this.get('item').clone().width(this.get('item').outerWidth()).addClass('ghost');
              })
              .swap(function(dragged, currentIndex, newIndex) {
                that.swapItemLocation(dragged, currentIndex, newIndex);
              })
              .plugin(Drag.plugins.scroller)
              .set('scrollContainer', function() {
                return that.getSidebarScroller();
              });
        }(i))  
      }
    },

    getSidebarContainer: function() {
      return this.$('.sidebar-container');
    },

    getSidebarScroller: function() {
      return this.$('.sidebar-scroller');
    },

    handleCollapseSection: function(ev) {
      var el = $(ev.currentTarget);

      el.toggleClass('collapsed');

      // Hide section items
      el.siblings('.sidebar-section-items').toggle();
    },

    handleAddNewItem: function(ev) {
      var sectionEl     = $(ev.currentTarget).closest('.sidebar-section'),
          section       = this.getElementDatum(sectionEl),
          sectionIndex  = this.getSections().indexOf(section),
          item          = null;
      
      item = this.callDelegateFn('requestAddItem', sectionIndex);

      this.appendNewItem(sectionEl, item);
    },

    handleDeleteItem: function(ev) {
      var itemEl        = $(ev.currentTarget).closest('.sidebar-section-item'),
          sectionIndex  = this.getSectionIndex(itemEl),
          item          = this.getElementDatum(itemEl),
          that          = this;

      // Stop click propagation
      ev.stopPropagation();

      this.callDelegateFn('requestConfirmDeleteItem', item)
        .then(function() {
          return that.callDelegateFn('requestDeleteItem', sectionIndex, item);
        })
        .then(function() {
          itemEl.remove();
        });
    },

    getSectionIndex: function(item) {
      return  $(item).closest('.sidebar-section').data('index');
    },

    handleSelectItem: function(ev) {
      var itemEl   = $(ev.currentTarget),
          data     = null;

      // Only allow one active item at a time per section
      if (!itemEl.hasClass('active') && this.isSelectable(itemEl)) {
        data = this.getElementDatum(itemEl);

        this.activateItem(itemEl);

        if (data) {
          this.callDelegateFn('requestActivateItem', data, this.getSectionIndex(itemEl));
        }

      }
    },

    activateItem: function(item) {
      var items   = null;

      item = $(item);

      if (this.getSingleSelect()) {
        items = this.$('.sidebar-section').find('.sidebar-section-item');
      } else {
        items = item.closest('.sidebar-section-items').find('.sidebar-section-item');
      }

      items.removeClass('active');
      item.addClass('active');
    },

    appendNewItem: function(section, item) {
      var itemsContainer = section.find('.sidebar-section-items'),
          sectionData    = this.getElementDatum(section);

      if (sectionData.template) {
        itemsContainer.append(this.template(sectionData.template, item, true));
      } else {
        itemsContainer.append(this.renderSidebarSectionItem(item, true));
      }

      var items = itemsContainer.find('.sidebar-section-item');

      if (sectionData.tabs) {
        items.addClass('tab-highlight');
      } else {
        items.addClass('border-highlight');
      }
    },

    isSelectable: function(item) {
      var sectionEl = item.closest('.sidebar-section'),
          section   = this.getElementDatum(sectionEl);

      return (section.unselectable != true);
    },

    selectItem: function(id, sectionIndex) {
      var sections = this.$('.sidebar-section'),
          item     = null;

      if (arguments.length > 1) {
        sections = sections.eq(sectionIndex);
      }

      item = sections.find('[data-id=' + id + ']');

      if (item && item.length > 0 && this.isSelectable(item)) {
        this.activateItem(item);
      }
      return this;
    },

    swapItemLocation: function(item, index, newIndex) {
      var sectionIndex = item.closest('.sidebar-section').data('index');

      this.callDelegateFn('requestSwapItem', sectionIndex, index, newIndex);
    },

    /* Delegate Functions */
    delegateInterfaces: {
      requestAddItem            : function() { return {}; },
      requestActivateItem       : function() {},
      requestConfirmDeleteItem  : function() { return $.when() },
      requestDeleteItem         : function() { return $.when() },
      requestSwapItem           : function() {}
    },

    callDelegateFn: function(fnName) {
      var delegate = this.getDelegate(),
          args     = Array.prototype.slice.call(arguments, 1);
          
      return this.getDelegateFn(fnName).apply(delegate, args);
    },

    getDelegateFn: function(fnName) {
      // Function specified
      if (this._getters[fnName]) {
        return this._getters[fnName];

      // Function exists in delegate
      } else if (this.getDelegate()[fnName]) {
        return this.getDelegate()[fnName];

      // Default function
      } else {
        return this.delegateInterfaces[fnName];
      }
    },

    interface: function(fnName, fn) {
      this._getters[fnName] = fn;

      return this;
    }

  });


  function renderButton(options) {
    var tagType = 'a';
    
    // Is this a help link?
    if (options.help != null) {
      options.target = helper.helpLink(options.help);
      options.position = 'left';
      options.icon = 'question-sign';
    }
    
    // What is the tag type of the button?
    if (options.tab) {
      tagType = 'button';
    }
    
    // Setting the base HTML of the button.
    var str = '<' + tagType + ' class="btn';
    
    // Setting the color configuration of the button.
    if (options.color) {
      str += ' ';
      if (this._colorMap[options.color]) {
        str += this._colorMap[options.color];
      } else {
        str += options.color;
      }
    } else {
      str += ' btn-default';
    }
    
    // Do we need to pull the button left?
    if (options.position == 'left') {
      str += ' pull-left';
    }

    // Is this button disabled
    if (options.disabled) {
      str += ' disabled';
    }
    
    // Closing the class declaration of the button.
    str += '"';
    
    // Does the button have an ID property?
    if (options.id) {
      str += ' id="' + options.id + '"';
    }
    
    // Does the button have an action property?
    if (options.action) {
      str += ' data-action="' + options.action + '"';
    }
    
    // Does the button have a tab index?
    if (options.tab) {
      str += ' tabindex="' + options.tab + '" type="button"';
    }
    
    // Does the button have a dismiss property to control a Twitter Bootstrap element?
    if (options.dismiss) {
      str += ' data-dismiss="modal"';
    }
    
    // Should this button be hidden?
    if (options.hide) {
      str += ' style="display: none;"';
    }
    
    // Does this button have a HREF target?
    if (options.target) {
      str += ' href="' + options.target + '" target="_blank"';
    }

    // Does this button have a title
    if (options.title) {
      str += ' title="' + options.title + '"';
    }
    
    // Closing the first part of the button tag.
    str += '>';

    // Add an icon to the template string.
    var addIcon = function() {
      str += '<span class="glyphicon glyphicon-' + options.icon;
      
      // What color is the color of the icon?
      if (options.color && options.color != 'white' && options.color != 'link') {
        str += ' glyphicon-white';
      }
      str += '"></span> ';
    };
    
    // Does the button have an icon that is not set to the right?
    if (options.icon && options.iconRight !== true) {
      addIcon();
    }
    
    // Closing the button tag.
    str += ((options.text != null) ? options.text : '');

    // Does the button have an icon set to the right?
    if (options.icon && options.iconRight === true) {
      // Add spacer between text and icon.
      str += ' ';
      addIcon();
    }

    str += '</' + tagType + '>';
    
    return new Handlebars.SafeString(str);
  };

  function renderApplyButton() {
    var options = {
      text    : 'Apply',
      color   : 'blue',
      action  : 'apply',
      icon    : 'ok'
    };

    renderButton(options);
  };

  function renderCancelButton() {
    var options = {
      text    : 'Cancel',
      color   : 'light',
      action  : 'cancel'
    };
    renderButton(options);
  };

  function renderCloseButton() {
    var options = {
      text    : 'Close',
      action  : 'close',
      icon    : 'share-alt'
    };
    renderButton(options);
  };

  Handlebars.registerHelper('checkbox', function(options) {
    var str         = '<div class="custom-checkbox"><input type="checkbox" ',
        uniqueId    = 'chckbx-' + (++this.checkboxId || (this.checkboxId = 1)),
        attributes  = options ? options.hash : null;

    str += 'id="' + uniqueId + '" ';

    if (attributes) {

      if (attributes.id) {
        str += 'data-id="' + attributes.id + '" ';
      }

      if (attributes.checked) {
        str += 'checked ';
      }

    } else if (options) {
      str += 'checked ';
    }

    str += '/><label for="' + uniqueId + '" unselectable="on"><span></span></label></div>';

    return new Handlebars.SafeString(str);
  });

  // Renders our default apply button
  Handlebars.registerHelper('applyButton', function() {
    return renderApplyButton();
  });
  
  // Renders a button with the given options      
  Handlebars.registerHelper('button', function(options) {
    return renderButton(options);
  });

  // Renders our default cancel button
  Handlebars.registerHelper('cancelButton', function() {
    return renderCancelButton();
  });

  // Renders our default close button
  Handlebars.registerHelper('closeButton', function() {
    return renderCloseButton();
  });


  // Renders our default close button
  Handlebars.registerHelper('calendar', function(date) {
    return moment(date).calendar();
  });

  // Render escaped HTML as regular HTML
  Handlebars.registerHelper('unescapeHTML', function(passedString) {
    return StringCommon.unescapeHTML(passedString);
  });

  // Encode the given string as a URI Component
  Handlebars.registerHelper('uriComponent', function(passedString) {
    return encodeURIComponent(passedString);
  });

  // Render the URL for help with the given help ID
  Handlebars.registerHelper('helpURLGenerate', function(helpId) {
    return helpURL + (helpId.length > 0 ? ('#CSHID=' + helpId) : '');
  });
  

  Handlebars.registerHelper('ifCond', function(v1, operator, v2, options) {
    switch (operator) {
      case '==':
        return (v1 == v2) ? options.fn(this) : options.inverse(this);
        break;
      case '===':
        return (v1 === v2) ? options.fn(this) : options.inverse(this);
        break;
      case '<':
        return (v1 < v2) ? options.fn(this) : options.inverse(this);
        break;
      case '<=':
        return (v1 <= v2) ? options.fn(this) : options.inverse(this);
        break;
      case '>':
        return (v1 > v2) ? options.fn(this) : options.inverse(this);
        break;
      case '>=':
        return (v1 >= v2) ? options.fn(this) : options.inverse(this);
        break;
      case '||':
        return (v1 || v2) ? options.fn(this) : options.inverse(this);
        break;
      case '&&':
        return (v1 && v2) ? options.fn(this) : options.inverse(this);
        break;             
      default:
        return options.inverse(this);
        break;
    }          
  });

  Handlebars.registerHelper('foreach', function(list) {
      var data       = {},
          selectedId = null,
          options    = {},
          len        = arguments.length,
          idField    = 'id';


      if (len > 2) {
        selectedId = arguments[1];
      }

      if (len > 3) {
        idField = arguments[2];
      }

      options = arguments[len-1];
      
      if (options.inverse && _.isEmpty(list)) {

        return options.inverse(this);
      }


      var mappedList = _.map(list, function(item, index) {
        
        data = Handlebars.createFrame(_.extend(data, options.data));

        data.index = index;
        data.first = index === 0
        data.last  = index === list.length-1;
        data.even  = index%2 === 0;
        data.odd   = !data.even;

        data.selected = item[idField] == selectedId;

        return options.fn(item, { data: data });

      });

      return mappedList.join('');
  });

  Handlebars.registerHelper('is', function(item1, item2) {
    var len     = arguments.length,
        options = arguments[len-1];
    
    if (item1 == item2) {
      return options.fn(this);
    } else {
      if (options.inverse) {
        return options.inverse(this);
      }
    }

    return '';
  });
  
  Handlebars.registerHelper('ProperCase', function(passedString) {
    return String(passedString).replace(/\w\S*/g, function(word) {
      return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
    });
  });

  // Lowercase the passed in string
  Handlebars.registerHelper('LowerCase', function(passedString) {
    return passedString ? String(passedString).toLowerCase() : passedString;
  });

  Handlebars.registerHelper('UpperCase', function(passedString) {
    return passedString ? String(passedString).toUpperCase() : passedString;
  });

  Handlebars.registerHelper('divide', function(first, second) {
    var num = Number(first)/Number(second);
    
    return num || 0;
  });

  Handlebars.registerHelper('debug', function(optionalValue) {
    if (optionalValue) {
      console.log("Value");
      console.log("====================");
      console.log(optionalValue);
    } else {
      console.log("Current Context");
      console.log("====================");
      console.log(this);
    }
  });

  Handlebars.registerHelper('moment', function(context, block) {
    if (context && context.hash) {
      block = _.clone(context);
      context = undefined;
    }
    var date = moment(context);

    // Reset the language back to default before doing anything else
    date.localeData('en');

    for (var i in block.hash) {
      if (date[i]) {
        date = date[i](block.hash[i]);
      } else {
        console.log('moment.js does not support "' + i + '"');
      }
    }
    return date;
  });

  Handlebars.registerHelper('getter', function(obj, property) {
    // if there is not object then return empy string
    if (!obj) {
      return '';
    }
    var getterName = 'get' + StringCommon.camelCase(String(property || ''));
    if (_.isFunction(obj[getterName])) {
      return obj[getterName]();
    } else {
      return obj[property];
    }
  });

  Handlebars.registerHelper('brToNewLine', function(str) {
    return StringCommon.brToNewLine(str);
  });

  Handlebars.registerHelper('inject', function(partialName, options) {
    var injection = {};

    if (options.fn) {
      options.fn(injection, { data: options.data });
    } else {
      injection = options.hash;
    }

    if (String(Handlebars.VERSION).slice(0, 1) === '3') {
      options = _.extend({}, options, {
        helpers: Handlebars.helpers,
        partials: Handlebars.partials
      });

      return Handlebars.VM.invokePartial(Handlebars.partials[partialName], injection, options);
    } else {

      return Handlebars.VM.invokePartial(Handlebars.partials[partialName], partialName, injection, Handlebars.helpers, Handlebars.partials, options.data);
    }
  });

  Handlebars.registerHelper('var', function(newVariableName, options) {
    this[newVariableName] = options.fn();
  });

  Handlebars.registerHelper('define', function(newVariableName, options) {
    this[newVariableName] = options.hash;
  });




  $.fn.getProperties = function(fn) {
    var els        = this.find('[data-property]'),
        property   = null,
        len        = els.length,
        properties = {},
        i          = 0;

    fn = fn || function(el) { return el.val(); }

    // loop through all the elements with the data-property
    // attribute and get its value to set on the properties object
    for (i = 0; i < len; ++i) {
      property = els.eq(i).data('property');
      ObjectCommon.setPropertyByNamespace(properties, property, fn(els.eq(i), property));
    }

    return properties;
  };




  $(window.document).on('click.closeValidation', '.error-close', function(ev) {
    $(ev.currentTarget).closest('[data-validate-error]').slideUp();
  });

  var ValidationObj = Vertebrae.Object.extend({

    formControlError: 'form.control.validation.error',

    validators: {},

    validate: function(fields, formEl) {
      var form    = formEl || $(window.document),
          fields  = fields || _.keys(this.validators),
          errors  = [];

      for (var i = 0, len = fields.length; i < len; i++) {
        var validation = this.validateField(fields[i], form);

        if (validation != true) {
          errors.push({
            field   : fields[i],
            message : validation
          });
        }
      }

      // Show new validation errors and hide old errors
      this.showValidationErrors(errors, form);

      return !errors.length;
    },

    validateField: function(field, form) {
      var fieldName   = field.charAt(0).toUpperCase() + field.substr(1),
          fieldEl     = form.find('[data-validate="' + field + '"]'),
          validators  = this.validators[field],
          validatorFn = null,
          valueFn     = this['get' + fieldName + 'FieldValue'],
          value       = null,
          validation  = null;

      // Get the field's value
      if (valueFn) {
        value = valueFn.call(this, fieldEl);
      } else {
        value = this.getGenericFieldValue(fieldEl);
      }

      // Pass the value through a validation function
      if (validators && validators.length) {
        for (var i = 0, len = validators.length; i < len; i++) {
          validatorFn = validators[i];

          if (_.isString(validatorFn)) {
            validatorFn = this[validatorFn];
          }

          if (_.isFunction(validatorFn)) {
            validation = validatorFn(value);
          } else {
            // Development use only
            throw Error('Invalid validation function for field "' + fieldName + '"' );
          }

          if (validation != true) {
            return validation;
          }
        }
      }
      
      return true;
    },

    getGenericFieldValue: function(fieldEl) {
      var value = null;

      if (fieldEl.length) {
        value = fieldEl.val();
      }

      return value;
    },

    hideValidationErrors: function(form) {
      var fields = form.find('[data-validate-error]');

      fields.slideUp();
    },

    showValidationErrors: function(errors, form) {
      var fieldEl       = null,
          errorEl       = null,
          error         = null,
          visibleErrors = form.find('[data-validate-error]');

      for (var i = 0, len = errors.length; i < len; i++) {
        error = errors[i]; // { field, message }

        // Only show failed validation, if field element exists
        fieldEl = form.find('[data-validate="' + error.field + '"]');

        if (fieldEl.length) {
          // Find if validation error element exists
          errorEl = fieldEl.siblings('[data-validate-error]');

          if (!errorEl.length) {
            // Create validation error fragment
            errorEl = Vertebrae.View.template(this.formControlError, error);

            // Allows initial slideDown animation, 
            // unable to animate properly using initial hidden display in css
            errorEl = $(errorEl);
            errorEl.css('display', 'none');

            // Insert validation error element next to the input field
            fieldEl.after(errorEl);

          } else {
            var index = visibleErrors.index(errorEl);            
            visibleErrors = visibleErrors.slice(index+1, index-1);

            // Replace text of existing error elements
            errorEl.find('.error-message').html(error.message);
          }

          errorEl.slideDown();
        }
      }

      // Hide all previously visible errors
      visibleErrors.slideUp();
    }

  }, {

    get: function() {
      if (!this._singleton) {
        this._singleton = new this();
      }

      return this._singleton;
    }

  });


this["E3Templates"] = this["E3Templates"] || {};
this["E3Templates"]["e3-common"] = this["E3Templates"]["e3-common"] || {};

this["E3Templates"]["e3-common"]["commonmenu.default.item"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  return "disabled";
  },"3":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "    <i class=\"icon icon-"
    + escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"icon","hash":{},"data":data}) : helper)))
    + "\"></i>\r\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helper, lambda=this.lambda, escapeExpression=this.escapeExpression, functionType="function", helperMissing=helpers.helperMissing, buffer = "<li class=\"";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.disabled : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\" data-index=\""
    + escapeExpression(lambda((data && data.index), depth0))
    + "\">\r\n  <span>\r\n";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.icon : depth0), {"name":"if","hash":{},"fn":this.program(3, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "    "
    + escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"text","hash":{},"data":data}) : helper)))
    + "\r\n  </span>\r\n</li>";
},"useData":true});

this["E3Templates"]["e3-common"]["commonmenu.init"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "<div class=\"common-menu "
    + escapeExpression(((helper = (helper = helpers.className || (depth0 != null ? depth0.className : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"className","hash":{},"data":data}) : helper)))
    + "\">\r\n  <ul class=\"common-menu-content\">\r\n  </ul>\r\n</div>\r\n\r\n";
},"useData":true});

this["E3Templates"]["e3-common"]["sidebar.init.container"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "    <div class=\"sidebar-header\">"
    + escapeExpression(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"title","hash":{},"data":data}) : helper)))
    + "</div>\r\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, buffer = "<div class=\"sidebar-container\">\r\n";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.title : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "  <div class=\"sidebar-scroller\"></div>\r\n</div>";
},"useData":true});

this["E3Templates"]["e3-common"]["sidebar.section"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  return "first";
  },"3":function(depth0,helpers,partials,data) {
  return "draggable";
  },"5":function(depth0,helpers,partials,data) {
  return "editable";
  },"7":function(depth0,helpers,partials,data) {
  var stack1, buffer = "";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.title : depth0), {"name":"if","hash":{},"fn":this.program(8, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"8":function(depth0,helpers,partials,data) {
  var stack1, helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, buffer = "    <div class=\"sidebar-section-header\">\r\n      <span class=\"icon icon-chevron-down pull-right-center collapse-icon\"></span>\r\n      <span>\r\n        "
    + escapeExpression(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"title","hash":{},"data":data}) : helper)))
    + "\r\n";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.description : depth0), {"name":"if","hash":{},"fn":this.program(9, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "      </span>\r\n    </div>\r\n";
},"9":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "        <br/>\r\n        <span class=\"sidebar-section-header-description\">"
    + escapeExpression(((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"description","hash":{},"data":data}) : helper)))
    + "</span>\r\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helper, lambda=this.lambda, escapeExpression=this.escapeExpression, functionType="function", helperMissing=helpers.helperMissing, buffer = "<div class=\"sidebar-section ";
  stack1 = helpers['if'].call(depth0, (data && data.first), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.dragDrop : depth0), {"name":"if","hash":{},"fn":this.program(3, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.editable : depth0), {"name":"if","hash":{},"fn":this.program(5, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\" data-index="
    + escapeExpression(lambda((data && data.index), depth0))
    + ">\r\n";
  stack1 = helpers.unless.call(depth0, (data && data.first), {"name":"unless","hash":{},"fn":this.program(7, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "  <div class=\"sidebar-section-items\"></div>\r\n  <div class=\"sidebar-section-add-item\"><span class=\"icon icon-plus-circle pull-right-center\"></span>Add "
    + escapeExpression(((helper = (helper = helpers.newItem || (depth0 != null ? depth0.newItem : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"newItem","hash":{},"data":data}) : helper)))
    + "</div>\r\n</div>\r\n";
},"useData":true});

this["E3Templates"]["e3-common"]["sidebar.section.item"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  return "active";
  },"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, buffer = "<div class=\"sidebar-section-item ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.selected : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "\" data-id="
    + escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"id","hash":{},"data":data}) : helper)))
    + ">\r\n  <div class=\"icon icon-align-justify pull-left dragger\"></div>\r\n  <div class=\"icon icon-minus-circle pull-right-center sidebar-section-delete-item\"></div>\r\n  <div class=\"sidebar-section-item-content\">\r\n    <span class=\"sidebar-section-item-text\">"
    + escapeExpression(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"title","hash":{},"data":data}) : helper)))
    + "</span>\r\n  </div>\r\n</div>";
},"useData":true});

this["E3Templates"]["e3-common"]["form.control.validation.error"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "<div class=\"form-control-validation-error\" data-validate-error=\""
    + escapeExpression(((helper = (helper = helpers.field || (depth0 != null ? depth0.field : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"field","hash":{},"data":data}) : helper)))
    + "\">\r\n  <div class=\"error-close pull-right\"><i class=\"fa-icon fa-icon-times\"></i></div>\r\n  <div class=\"error-icon pull-left\"><i class=\"fa-icon fa-icon-exclamation-circle\"></i></div>\r\n  <div class=\"error-message\">"
    + escapeExpression(((helper = (helper = helpers.message || (depth0 != null ? depth0.message : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"message","hash":{},"data":data}) : helper)))
    + "</div>\r\n</div>";
},"useData":true});


  return {
    Drag: DragCommon,
    Drop: DropCommon,
    Browser: BrowserCommon,
    String: StringCommon,
    Object: ObjectCommon,
    SidebarView: SidebarView,
    ValidationObj: ValidationObj,
    templates: this['E3Templates']['e3-common'],
    version: '0.0.32'
  };
  

}));

